import styled from "styled-components";
import theme from "../../../../Styles/theme";


export const InputContainer = styled.div`

   
    margin-top:5vh;
    width:calc(20% + 200px);
`;

export const InputButton = styled.div`

    display: flex;
    align-items: center;
    justify-content:center;
    width:100%;

    margin-top:2vh;

`;


export const HelperSpan = styled.div`
    display: flex;
    align-items: center;
    margin-top:10vh;

`;


export const Span = styled.span`

    color:${theme.colors.dark};
    display: flex;
    align-items: center;
    justify-content:center;

    cursor: pointer;

    &:hover{
        opacity: 0.8;
    }

`;